<label for="feature_{{feature.id}}">
  {{ feature.header }}<span *ngIf="feature.unitHeader">, {{ feature.unitHeader }}</span>
  <span *ngIf="isRequired()"> *</span>
  <span *ngIf="feature.comment" nbTooltip="{{feature.comment}}"><nb-icon icon="bulb-outline"></nb-icon></span>
</label>

<div class="accordion-item__right">
  <form [formGroup]="form" style="width: 100%;">
    <div style="display: flex; width: 100%;">
      <input nbInput
             type="text"
             fullWidth
             fieldSize="medium"
             [placeholder]="widthPlaceholder"
             formControlName="width"
      />
      <input nbInput
             class="ms-2"
             type="text"
             fullWidth
             fieldSize="medium"
             [placeholder]="heightPlaceholder"
             formControlName="height"
      />
      <input nbInput
             class="ms-2"
             type="text"
             fullWidth
             fieldSize="medium"
             [placeholder]="depthPlaceholder"
             formControlName="depth"
      />
    </div>
    <div *ngIf="form.invalid && hasSizeErrors()">
      <div *ngIf="isPatternError()" class="text-danger" i18n="@@FeatureValueIncorrectError">
        Не корректное значение
      </div>
    </div>
  </form>
  <div class="accordion-item__right-info">
    <div class="state-warn" *ngIf="form.valid && isShowEmptyWarning()">
      <nb-icon icon="alert-triangle-outline"/>
    </div>
    <div class="state-err" *ngIf="form.invalid">
      <nb-icon icon="alert-circle-outline"/>
    </div>
    <div class="state-success" *ngIf="form.valid && !isSizeNoEmpty()">
      <nb-icon icon="checkmark-outline"/>
    </div>

    <a [routerLink]="['/cabinet/pim/feature/edit/', feature.featureId]"
       class="entityID"
       target="_blank"
       i18n-nbTooltip="@@OpenFeatureInNewWindow"
       nbTooltip="Открыть характеристику в новом окне"
       *ngIf="featureLink">
      #{{ feature.featureId }}
    </a>
  </div>
</div>
